
import { defineComponent } from "vue";
import { useBooks } from "@/services";
import { storeToRefs } from "pinia";
import Spinner from "@/components/shared/Spinner.vue";

export default defineComponent({
  name: "FileUpload",
  components: {
    Spinner,
  },
  setup() {
    let isLoadingUpload = false;
    let uploadError = false;
    const { dataSetDefinition } = storeToRefs(useBooks());

    return {
      dataSetDefinition,
      isLoadingUpload,
      uploadError,
    };
  },
  methods: {
    async uploadfile() {
      this.isLoadingUpload = true;
      try {
        await useBooks().upload();
        this.$bvModal.hide("book-upload-modal");
        this.isLoadingUpload = false;
        useBooks().clearFile();
        this.$root.$bvToast.toast("Book uploaded sucessfully", {
          title: "Book upload",
          variant: "success",
          solid: true,
        });
      } catch (error) {
        this.isLoadingUpload = false;
        this.uploadError = true;
      }
    },
  },
});
